import { useAtomValue } from 'jotai';

import { displayBusinessNameAtom } from '@/lib/stores/survey/business';
import { employeesAtom } from '@/lib/stores/survey/common';

export const useSurveyProgressBar = () => {
  const displayName = useAtomValue(displayBusinessNameAtom);
  const employees = useAtomValue(employeesAtom);
  return {
    companyName: displayName,
    hasEmployees: !!employees?.length
  };
};
